/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/flex-layout/flex";
import * as i2 from "@angular/flex-layout/extended";
import * as i3 from "@angular/common";
function ExtNoDataComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.initial);
} }
function ExtNoDataComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.dataName);
} }
function ExtNoDataComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.message);
} }
var ExtNoDataComponent = /** @class */ (function () {
    function ExtNoDataComponent() {
        this.forceIcon = false;
    }
    ExtNoDataComponent.ɵfac = function ExtNoDataComponent_Factory(t) { return new (t || ExtNoDataComponent)(); };
    ExtNoDataComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ExtNoDataComponent, selectors: [["gh-ext-no-data"]], inputs: { initial: "initial", dataName: "dataName", message: "message", forceIcon: "forceIcon" }, decls: 6, vars: 4, consts: [["fxLayout", "column", "fxLayoutAlign", "start center", 1, "m-content"], ["fxShow", "", "src", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMjEuNjUgMjIxLjgwNyI+CiAgICA8ZGVmcz4KICAgICAgICA8c3R5bGU+CiAgICAgICAgICAgIC5jbHMtMXtmaWxsOiNhMmEyYTJ9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJpY25fc2VhcmNoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODc3IC0yOTcpIj4KICAgICAgICA8cGF0aCBpZD0iUmVjdGFuZ2xlXzE4MyIgZD0iTTAgMGgxNnY4NEgweiIgY2xhc3M9ImNscy0xIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxODMiIHRyYW5zZm9ybT0icm90YXRlKC00NSAxMDY4LjUyNiAtMTAxMS4xMjcpIi8+CiAgICAgICAgPHBhdGggaWQ9IlN1YnRyYWN0aW9uXzEiIGQ9Ik04OCAxODdhODguNjQ5IDg4LjY0OSAwIDAgMS0xNy43MzUtMS43ODhBODcuNTE4IDg3LjUxOCAwIDAgMSAzOC44IDE3MS45NzFhODguMjU4IDg4LjI1OCAwIDAgMS0zMS44ODQtMzguNzE3IDg3LjU1NiA4Ny41NTYgMCAwIDEtNS4xMjgtMTYuNTE5IDg4Ljg1NiA4OC44NTYgMCAwIDEgMC0zNS40N0E4Ny41MTggODcuNTE4IDAgMCAxIDE1LjAyOSA0OS44YTg4LjI1OCA4OC4yNTggMCAwIDEgMzguNzE4LTMxLjg4NSA4Ny41NTcgODcuNTU3IDAgMCAxIDE2LjUxOS01LjEyOCA4OC44NTYgODguODU2IDAgMCAxIDM1LjQ3IDBBODcuNTE4IDg3LjUxOCAwIDAgMSAxMzcuMiAyNi4wMjlhODguMjU4IDg4LjI1OCAwIDAgMSAzMS44ODMgMzguNzE4IDg3LjU1NiA4Ny41NTYgMCAwIDEgNS4xMjggMTYuNTE5IDg4Ljg1NiA4OC44NTYgMCAwIDEgMCAzNS40NyA4Ny41MTggODcuNTE4IDAgMCAxLTEzLjI0IDMxLjQ2NCA4OC4yNTggODguMjU4IDAgMCAxLTM4LjcxOCAzMS44ODMgODcuNTU2IDg3LjU1NiAwIDAgMS0xNi41MTkgNS4xMjhBODguNjQ5IDg4LjY0OSAwIDAgMSA4OCAxODd6bTAtMTYzYTc0LjY1MSA3NC42NTEgMCAwIDAtNDEuOTMzIDEyLjgwOSA3NS4yMTggNzUuMjE4IDAgMCAwLTI3LjE3MyAzMyA3NC45IDc0LjkgMCAwIDAgNi45MTUgNzEuMTI3IDc1LjIyIDc1LjIyIDAgMCAwIDMzIDI3LjE3MyA3NC45IDc0LjkgMCAwIDAgNzEuMTI3LTYuOTE1IDc1LjIxOCA3NS4yMTggMCAwIDAgMjcuMTczLTMzIDc0LjkgNzQuOSAwIDAgMC02LjkxNS03MS4xMjcgNzUuMjE3IDc1LjIxNyAwIDAgMC0zMy0yNy4xNzNBNzQuNTMxIDc0LjUzMSAwIDAgMCA4OCAyNHoiIGNsYXNzPSJjbHMtMSIgZGF0YS1uYW1lPSJTdWJ0cmFjdGlvbiAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NzcgMjg2KSIvPgogICAgPC9nPgo8L3N2Zz4K", 1, "m-image", 3, "fxHide.lt-md"], [1, "m-no-data"], ["class", "ext-primary-color", 4, "ngIf"], [4, "ngIf"], ["class", "m-no-data-title", 4, "ngIf"], [1, "ext-primary-color"], [1, "m-no-data-title"]], template: function ExtNoDataComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "img", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, ExtNoDataComponent_span_3_Template, 2, 1, "span", 3);
            i0.ɵɵtemplate(4, ExtNoDataComponent_span_4_Template, 2, 1, "span", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, ExtNoDataComponent_div_5_Template, 2, 1, "div", 5);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("fxHide.lt-md", !ctx.forceIcon);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.initial);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.dataName);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.message);
        } }, directives: [i1.DefaultLayoutDirective, i1.DefaultLayoutAlignDirective, i2.DefaultShowHideDirective, i3.NgIf], styles: ["[_nghost-%COMP%] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center; }\n\n.m-content[_ngcontent-%COMP%] {\n  padding: 40px;\n  text-align: center; }\n\n.m-no-data-title[_ngcontent-%COMP%] {\n  margin: 25px 0;\n  font-size: 24px;\n  line-height: 1.21; }\n\n@media (max-width: 959px) {\n  .m-image[_ngcontent-%COMP%] {\n    width: 140px; } }\n\n@media (max-width: 599px) {\n  .m-no-data[_ngcontent-%COMP%] {\n    font-size: 65px; } }\n\n@media (min-width: 600px) and (max-width: 959px) {\n  .m-no-data[_ngcontent-%COMP%] {\n    font-size: 100px; } }\n\n@media (min-width: 960px) {\n  .m-no-data[_ngcontent-%COMP%] {\n    font-size: 150px; }\n  .m-image[_ngcontent-%COMP%] {\n    width: 225px; } }\n\n@media (max-height: 320px) {\n  .m-image[_ngcontent-%COMP%] {\n    width: 80px; } }"] });
    return ExtNoDataComponent;
}());
export { ExtNoDataComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ExtNoDataComponent, [{
        type: Component,
        args: [{
                selector: 'gh-ext-no-data',
                templateUrl: 'ext-no-data.component.html',
                styleUrls: ['ext-no-data.component.scss'],
            }]
    }], null, { initial: [{
            type: Input
        }], dataName: [{
            type: Input
        }], message: [{
            type: Input
        }], forceIcon: [{
            type: Input
        }] }); })();
